// #region imports

// --- angular
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';

// --- 3rd Party
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// --- HS Code
import * as c from './';
import { RouterModule } from '@angular/router';
import { AntiForgeryTokenDirective } from './directives/anti-forgery-token.directive';
import { ReportModalComponent } from './report-modal/report-modal.component';
import { CookiePolicyModule } from './cookie-policy/cookie-policy.module';

// #endregion

@NgModule({
  declarations: [c.AppToastComponent, AntiForgeryTokenDirective, ReportModalComponent],
  imports: [CommonModule, RouterModule, TranslateModule, NgbModule, CookiePolicyModule],
  exports: [c.AppToastComponent, NgbModule, CookiePolicyModule],
  entryComponents: [ReportModalComponent]
})
export class CoreModule extends c.EnsureModuleLoadedOnceGuard {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    super(parentModule);
  }
}
